// eslint-disable-next-line
import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  Input,
  CardBody,
  FormGroup,
  Button,
  Label,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import { hideLoader, showLoader } from "../../../../redux/actions/loader-data";
import { ToastsStore } from "react-toasts";
import moment from "moment";
import { deepClone } from "../../../../helper-methods";
// import { Paginate } from "./Pagination";
import {
  getAllFilesList,
  getAllImagesList,
  createVmTemplate,
} from "../../../../http/http-calls";
// import Switch from "react-switch";
import config from "../../../../config";
import { template } from "lodash";
import Select from "react-dropdown-select";
import styled from "styled-components";
import Tooltip from '@mui/material/Tooltip';
import Switch from '@mui/material/Switch';

const StyledOption = styled.span`
  padding: 0;
  color: #555;
  border-radius: 3px;
  margin: 3px;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  transition: all 1s ease-in;

  span {
    display: none;
    transition: all 1s ease-in;
  }

  a {
    margin: 0 5px;
  }

  :hover {
    background: #f2f2f2;

    span {
      display: inline;
      margin: 0 0 0 5px;
      color: red;
    }
  }
`;
const StyledItem = styled.div`
  padding: 10px;
  color: #555;
  border-radius: 3px;
  margin: 3px;
  cursor: pointer;

  :hover {
    background: #f2f2f2;
  }
`;
class TemplateCreation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 1,
      input: false,
      template: {
        name: "",
        description: "",
        baseBin: "virsh",
        vmimage: [],
        dockertext: "",
        dockerimage: [],
        textArea: "",
        defaulticon: "",
        defaultvmimage: "",
        requiresSecondaryDisk: false,
        pictureId: [],
        active: false,
      },
      tempDefaultvalue: "",
      fieldsToShow: [],
      vmTemplates: deepClone(config.vmTemplateFields),
      isDirtyTemplate: {
        name: false,
        baseBin: false,
        vmimage: false,
        textArea: false,
        pictureId: false,
      },
      errors: {},
      currentPage: 1,
      totalPages: "",
      searchItem: "",
      imageList: [],
      iconList: [],
      selectedFile: null,
      previewImg: null,
      selectedIcons: [],
    };
  }
  componentDidMount = () => {
    this._getAllImage();
    this._getAllIcons();
  };
  //changing format of createdAt
  _changeFormat = (data) => {
    return moment(data).format("MMM DD, hh:mm a");
  };

  //for pagination
  _paginate = (pageNumber) => {
    this._getTeamsList(pageNumber);
  };

  // To get the Image assets
  _getAllImage = async () => {
    let res = await getAllImagesList();
    console.log("res :>> ", res);
    this.setState({ imageList: res.files });
  };

  // To get the icon assets
  _getAllIcons = async () => {
    let res = await getAllFilesList({ isIcon: true });
    console.log("res :>> ", res);
    this.setState({ iconList: res.files });
  };
  // handleChange
  handleChange = () => {
    let tempFieldsToShow = this.state.fieldsToShow.filter(
      (each) => each.isSelected !== undefined && each.isSelected !== false
    );
    // tempFieldsToShow.forEach(it=>delete it.type);
    console.log(tempFieldsToShow);
    this.setState(
      { input: !this.state.input, fieldsToShow: tempFieldsToShow },
      () => {
        // this._handleOnChange(
        //   "textArea",
        //   JSON.stringify(this.state.fieldsToShow)
        // )

        // console.log(!this.state.input,template.textArea=="[]")
        // if(!this.state.input&&template.textArea!==`[]`){
        //   console.log(JSON.parse(template.textArea))
        //   this.setState({
        //     fieldsToShow:JSON.parse(template.textArea)
        //   })
        // }
        if (!this.state.input && template.textArea !== `[]`) {
          this.fieldsToShowUpdating();
        } else {
          this._handleOnChange(
            "textArea",
            JSON.stringify(this.state.fieldsToShow, undefined, 2)
          );
        }
      }
    );
    //  this.setState({ fieldsToShow: tempFieldsToShow });
  };
  fieldsToShowUpdating = () => {
    let { vmTemplates } = this.state;
    console.log(JSON.parse(this.state.template.textArea));
    this.setState(
      {
        fieldsToShow: JSON.parse(this.state.template.textArea),
      },
      () => {
        let updatedVmTemplates = vmTemplates.map(
          (obj) =>
            JSON.parse(this.state.template.textArea).find(
              // eslint-disable-next-line
              (o) => o.fieldName == obj.fieldName
            ) || obj
        );
        this.setState({ vmTemplates: updatedVmTemplates });
      }
    );
  };
  //handling input here
  _handleOnChange = (field, value) => {
    console.log(field, value);
    const { template, isDirtyTemplate } = this.state;
    // template[field] = value;
    // isDirtyTemplate[field] = true;
    // this.setState({ template });
    // this.setState({ template }, () => {
    //   console.log(isDirtyTemplate[field], field);
    //   if (isDirtyTemplate[field]) this._validationTemplate(value);
    // });
    // eslint-disable-next-line
    if (field == "baseBin") {
      this.setState(
        {
          template: {
            ...this.state.template,
            [field]: value,
            defaultvmimage: "",
            vmimage: [],
            dockerimage: []
          },
          fieldsToShow: [],
          vmTemplates: deepClone(config.vmTemplateFields),
        },
        () => {
          console.log(isDirtyTemplate[field], field);
          if (isDirtyTemplate[field]) this._validationTemplate(value);
        }
      );
      // eslint-disable-next-line
    } else if (field == "vmimage" || field == "dockerimage") {
      this.setState(
        {
          template: {
            ...this.state.template,
            vmimage:
              // eslint-disable-next-line
              field == "vmimage"
                ? this.state.template.vmimage.concat([value])
                : [],
            dockerimage:
              // eslint-disable-next-line
              field == "dockerimage"
                ? [...new Set(this.state.template.dockerimage.concat([value]))]
                : [],
            dockertext: "",
          },
        },
        () => {
          console.log(isDirtyTemplate[field], field);
          if (isDirtyTemplate[field]) this._validationTemplate(value);
        }
      );
    } else {
      template[field] = value;
      this.setState({ template }, () => {
        console.log(isDirtyTemplate[field], field);
        if (isDirtyTemplate[field]) this._validationTemplate(value);
      });
    }
  };

  markDirty = (fieldName, fieldvalue) => {
    const { isDirtyTemplate } = this.state;
    console.log(fieldName);
    isDirtyTemplate[fieldName] = true;

    this.setState(
      { isDirtyTemplate },
      () => console.log(isDirtyTemplate),
      this._validationTemplate(fieldvalue)
    );
    // console.log(this.state.errors,this.state.isDirtyTemplate);
  };

  _validationTemplate = (value) => {
    const { template, errors, isDirtyTemplate } = this.state;
    console.log('object')
    Object.keys(template).forEach((each) => {
      if (each === "name" && isDirtyTemplate.name) {
        if (!template.name.trim().length) {
          errors.nameTemplate = "Name is Required";
        } else {
          delete errors["nameTemplate"];
          isDirtyTemplate.name = false;
        }
      } else if (each === "baseBin" && isDirtyTemplate.baseBin) {
        if (!template.baseBin.trim().length) {
          errors.baseBin = "VM Type is Required";
        } else {
          delete errors[each];
          isDirtyTemplate.baseBin = false;
        }
      } else if (each === "vmimage" && isDirtyTemplate.vmimage) {
        // eslint-disable-next-line
        if (!template.vmimage.length > 0 && template.baseBin == "virsh") {
          errors.vmimage = "VM Image is Required";
        } else {
          delete errors[each];
          isDirtyTemplate.vmimage = false;
        }
      } else if (each === "dockerimage" && isDirtyTemplate.dockerimage) {
        // eslint-disable-next-line
        if (!template.dockerimage.length > 0 && template.baseBin == "docker") {
          errors.dockerimage = "Docker Image is Required";
        } else {
          delete errors[each];
          isDirtyTemplate.dockerimage = false;
        }
      } else if (
        // eslint-disable-next-line
        each == "textArea" &&
        this.state.input &&
        isDirtyTemplate.textArea
      ) {
        console.log(value);
        //  let data= JSON.stringify(value, undefined, 0)
        try {
          JSON.parse(value);
          delete errors[each];
          isDirtyTemplate.textArea = false;
        } catch {
          console.log("error");
          errors.textArea = "Not a Valid Json";
        }
      }
    });
    if (
      isDirtyTemplate.selectedFile &&
      !this.state.selectedFile &&
      !this.state.selectedIcons.length
    ) {
      errors.selectedFile = "*Select OR Upload an Icon";
    } else if (
      isDirtyTemplate.selectedFile &&
      this.state.selectedFile &&
      !config.supportedFileFormats.includes(this.state.selectedFile.type)
    ) {
      errors.selectedFile = "Please select an image file";
    } else {
      delete errors.selectedFile;
    }
    this.setState({ errors });
    console.log("err", this.state.errors);
    return Object.keys(errors).length ? errors : {};
  };

  _Template = () => {
    let isDirtyTemplate = {
      name: true,
      baseBin: true,
      vmimage: true,
      dockerimage: true,
    };
    this.setState({ isDirtyTemplate }, () => {
      // eslint-disable-next-line
      let arrayDataType = this.state.fieldsToShow.filter(item => item.dataType == "Array")
        .map(each => each?.defaultValue !== undefined &&
          this.checkArrayHasDuplicate(each?.defaultValue.split(",")))

      console.log(arrayDataType.includes(true))

      let errors = this._validationTemplate()
      console.log(JSON.stringify(errors) === '{}' && !arrayDataType.includes(true))
      if (JSON.stringify(errors) === '{}' && !arrayDataType.includes(true)) {
        let { template, fieldsToShow } = this.state;

        console.error('========')
        console.error(fieldsToShow)
        console.error('========')

        let fieldstoSend = fieldsToShow
          .filter(
            (each) => each.isSelected !== undefined && each.isSelected !== false
          )
          .map((item) => ({
            dataType: item.dataType,
            isEditable: item.isEditable,
            isMandatory: item.isMandatory,
            fieldName: item.fieldName,
            label: item.label,
            defaultValue:
              // eslint-disable-next-line
              item.dataType == "Number"
                ? Number(item.defaultValue)
                :
                // eslint-disable-next-line
                item.dataType == "Array" ? item.defaultValue.split(',') : item.defaultValue,
          }));
        let data = {
          name: template.name,
          description: template.description,
          baseBin: template.baseBin,
          imagesToShow:
            template.vmimage.length > 0 ? template.vmimage : undefined,
          dockerImagesToShow:
            template.dockerimage.length > 0 ? template.dockerimage : undefined,
          defaultIconId: template?.pictureId[0]?.id,
          defaultVMImageId:
            // eslint-disable-next-line
            template.baseBin == "virsh" ? template.defaultvmimage : undefined,
          defaultDockerImage:
            // eslint-disable-next-line
            template.baseBin == "docker" ? template.defaultvmimage : undefined,
          fieldsToShow: fieldstoSend.length > 0 ? fieldstoSend : undefined,
          isActive: template.active,
          requiresSecondaryDisk: template.requiresSecondaryDisk,
        };
        console.log(data);
        createVmTemplate(data)
          .then((resp) => {
            this.setState({
              template: {
                name: "",
                description: "",
                baseBin: "virsh",
                vmimage: [],
                dockerimage: [],
                textArea: "",
                defaulticon: "",
                defaultvmimage: "",
                requiresSecondaryDisk: false,
                pictureId: [],
                active: false,
              },
              isDirtyTemplate: {
                name: false,
                baseBin: false,
                vmimage: false,
                textArea: false,
                pictureId: false,
              },
            });
            this.props.hideLoader();
            ToastsStore.success("VM Template Created successfully");
          })
          .catch((error) => {
            console.log("error :", error);
            this.props.hideLoader();
            ToastsStore.error("VM Template Creation Error:- " + error.reason);
          });
      }
    });
  };

  _fieldOnChange = (fieldName, fieldValue, item) => {
    console.log(fieldName, fieldValue, item);
    const { fieldsToShow } = this.state;
    if (fieldsToShow.length > 0) {
      let objIndex = fieldsToShow.findIndex(
        (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
      );
      if (objIndex >= 0) {
        // this.setState({fieldsToShow:[...this.state.fieldsToShow,{...fieldsToShow[a],[fieldName]:fieldValue}]})
        const updatedObj = {
          ...fieldsToShow[objIndex],
          [fieldName]: fieldValue,
        };
        const updatedfieldtoShow = [
          ...fieldsToShow.slice(0, objIndex),
          updatedObj,
          ...fieldsToShow.slice(objIndex + 1),
        ];
        console.log(updatedfieldtoShow);
        this.setState({ fieldsToShow: updatedfieldtoShow });
      } else {
        this.setState({
          fieldsToShow: [
            ...this.state.fieldsToShow,
            {
              ...item,
              [fieldName]: fieldValue,
              isMandatory: false,
              isEditable: false,
            },
          ],
        });
      }
    } else {
      this.setState({
        fieldsToShow: [
          ...this.state.fieldsToShow,
          {
            ...item,
            [fieldName]: fieldValue,
            isMandatory: false,
            isEditable: false,
          },
        ],
      });
    }
    this._updateTemplate(fieldName, fieldValue, item);
  };

  _updateTemplate = (fieldName, fieldValue, item) => {
    const { vmTemplates } = this.state;

    let objIndex = vmTemplates.findIndex(
      (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
    );
    if (objIndex >= 0) {
      // this.setState({fieldsToShow:[...this.state.fieldsToShow,{...fieldsToShow[a],[fieldName]:fieldValue}]})
      const updatedObj = {
        ...vmTemplates[objIndex],
        [fieldName]: fieldValue,
      };
      const updatedfieldtoShow = [
        ...vmTemplates.slice(0, objIndex),
        updatedObj,
        ...vmTemplates.slice(objIndex + 1),
      ];
      this.setState({ vmTemplates: updatedfieldtoShow });
    }
  };

  _customOptionRenderer = ({ item, props, state, methods }) => {
    console.log(item);
    return (
      <StyledOption>
        <img src={item.url} width={30} alt={item.name} />
        &nbsp;
        {item.name}
        <span
          onClick={() => {
            methods.removeItem(null, item);
            this.setState({ selectedIcons: [] }, () => {
              this._validateFields();
            });
          }}
        >
          &times;
        </span>
      </StyledOption>
    );
  };
  _customItemRenderer = ({ item, itemIndex, props, state, methods }) => {
    const { selectedIcons } = deepClone(this.state);
    console.log(item);

    return (
      <StyledItem>
        <div
          onClick={() => {
            console.log("selectedIcons :>> ", item);
            methods.addItem(item);
            const { isDirtyTemplate } = deepClone(this.state);
            isDirtyTemplate.pictureId = true;
            const isAlreadyPresent =
              selectedIcons.length && selectedIcons[0].id === item.id;
            this.setState(
              {
                selectedIcons: isAlreadyPresent ? [] : [item],
                selectedFile: null,
                previewImg: null,
                isDirtyTemplate,
              },
              () => {
                this._validationTemplate();
              }
            );
          }}
        >
          <img src={item.url} width={30} alt={item.name} /> &nbsp;
          {item.name}
        </div>
      </StyledItem>
    );
  };

  _handleOnDelete = (value) => {
    console.log(value);
    let list = this.state.template.vmimage.filter((each) => each !== value);

    console.log(list);
    this.setState({
      template: {
        ...this.state.template,
        vmimage: list,
      },
    });
  };

  _handleOnDockerDelete = (value) => {
    let list = this.state.template.dockerimage.filter((each) => each !== value);
    console.log(list);
    this.setState({
      template: {
        ...this.state.template,
        dockerimage: list,
      },
    });
  };

  checkArrayHasDuplicate = (arr) => {
    console.log(arr);
    // eslint-disable-next-line
    let duplicates = arr.filter((item, index) => arr.indexOf(item) != index);
    return duplicates.length > 0 ? true : false;
  };
  // _fieldOnDefaultChange = (fieldName, fieldValue, item, index) => {
  //   console.log(fieldName, fieldValue, item);
  //   const { fieldsToShow } = this.state;
  //   let objIndex = fieldsToShow.findIndex(
  //     (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  //   );
  //   const updatedObj = {
  //     ...fieldsToShow[objIndex],
  //     [fieldName]: fieldsToShow[objIndex].defaultValue
  //       ? [...fieldsToShow[objIndex].defaultValue, fieldValue]
  //       : [fieldValue],
  //   };
  //   const updatedfieldtoShow = [
  //     ...fieldsToShow.slice(0, objIndex),
  //     updatedObj,
  //     ...fieldsToShow.slice(objIndex + 1),
  //   ];
  //   console.log(updatedfieldtoShow);
  //   this.setState(
  //     { fieldsToShow: updatedfieldtoShow, tempDefaultvalue: "" },
  //     () =>
  //       this._fieldOnDefaultChangeUpdateVmtemplate(
  //         fieldName,
  //         fieldValue,
  //         item,
  //         index
  //       )
  //   );
  // };

  // _fieldOnDefaultChangeUpdateVmtemplate = (
  //   fieldName,
  //   fieldValue,
  //   item,
  //   index
  // ) => {
  //   console.log(fieldName, fieldValue, item);
  //   const { vmTemplates } = this.state;
  //   let objIndex = vmTemplates.findIndex(
  //     (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  //   );
  //   const updatedObj = {
  //     ...vmTemplates[objIndex],
  //     [fieldName]: vmTemplates[objIndex].defaultValue
  //       ? [...vmTemplates[objIndex].defaultValue, fieldValue]
  //       : [fieldValue],
  //   };
  //   const updatedfieldtoShow = [
  //     ...vmTemplates.slice(0, objIndex),
  //     updatedObj,
  //     ...vmTemplates.slice(objIndex + 1),
  //   ];
  //   console.log(updatedfieldtoShow);
  //   this.setState({ vmTemplates: updatedfieldtoShow });
  // };

  // _handleOnDefaultvalueDelete = (item, each) => {
  //   console.log(item, each);
  //   const { fieldsToShow } = this.state;
  //   let objIndex = fieldsToShow.findIndex(
  //     (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  //   );
  //   const updatedObj = {
  //     ...fieldsToShow[objIndex],
  //     defaultValue: fieldsToShow[objIndex].defaultValue.filter(
  //       (item) => item !== each
  //     ),
  //   };
  //   const updatedfieldtoShow = [
  //     ...fieldsToShow.slice(0, objIndex),
  //     updatedObj,
  //     ...fieldsToShow.slice(objIndex + 1),
  //   ];
  //   this.setState({ fieldsToShow: updatedfieldtoShow }, () =>
  //     this._handleOnDefaultvalueDeleteVmtemplate(item, each)
  //   );
  // };

  // _handleOnDefaultvalueDeleteVmtemplate = (item, each) => {
  //   const { vmTemplates } = this.state;
  //   let objIndex = vmTemplates.findIndex(
  //     (o) => o.fieldName === item.fieldName && o.dataType === item.dataType
  //   );
  //   const updatedObj = {
  //     ...vmTemplates[objIndex],
  //     defaultValue: vmTemplates[objIndex].defaultValue.filter(
  //       (item) => item !== each
  //     ),
  //   };
  //   const updatedfieldtoShow = [
  //     ...vmTemplates.slice(0, objIndex),
  //     updatedObj,
  //     ...vmTemplates.slice(objIndex + 1),
  //   ];
  //   this.setState({ vmTemplates: updatedfieldtoShow });
  // };

  render() {
    console.log(this.state);
    const { errors, template } = deepClone(this.state);
    let VmTemplate = this.state.vmTemplates.filter(
      (i) =>
        // eslint-disable-next-line
        i.type[0] == this.state.template.baseBin ||
        // eslint-disable-next-line
        i.type[1] == this.state.template.baseBin
    );
    console.log(VmTemplate);
    let preView =
      this.state.template.vmimage &&
      this.state.imageList.filter((item) =>
        // eslint-disable-next-line
        this.state.template.vmimage.some((each) => item.id == each)
      );
    let dockerPreView =
      this.state.template.dockerimage &&
      this.state.imageList.filter((item) =>
        // eslint-disable-next-line
        this.state.template.dockerimage.some((each) => item.id == each)
      );
    console.log(dockerPreView);

    return (
      <Row>
        <Col xs="12">
          <Card>
            <CardBody>
              {/* template Creation */}

              <Row>
                <Col xs="12">
                  <Card>
                    <CardBody>
                      {/* template Creation */}

                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label>
                              Name<sup>*</sup>
                            </Label>
                            <Input
                              type="text"
                              placeholder="Name"
                              name="name"
                              value={template.name}
                              onChange={(e) =>
                                this._handleOnChange("name", e.target.value)
                              }
                            />
                            {errors && (
                              <div className="validation-error">
                                {errors.nameTemplate}
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label>
                              VM Type<sup>*</sup>
                            </Label>
                            <Input
                              type="select"
                              placeholder="Vm Type"
                              name="baseBin"
                              value={template.baseBin}
                              onChange={(e) =>
                                this._handleOnChange("baseBin", e.target.value)
                              }
                            >
                              <option value={"virsh"}>virsh</option>
                              <option value={"docker"}>docker</option>
                            </Input>
                            {errors && (
                              <div className="validation-error">{errors.baseBin}</div>
                            )}
                          </FormGroup>
                        </Col>
                        <Col md="12">
                          <FormGroup>
                            <Label>Description</Label>
                            <Input
                              type="textarea"
                              placeholder="Description"
                              name="description"
                              value={template.description}
                              onChange={(e) =>
                                this._handleOnChange("description", e.target.value)
                              }
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row></Row>
                      <Row>
                        <Col md="12">
                          {
                            // eslint-disable-next-line
                            this.state.template.baseBin == "docker" ? (
                              <FormGroup>
                                <Label>
                                  Docker Images<sup>*</sup>
                                </Label>
                                <Input
                                  type="text"
                                  placeholder="Enter Docker Images and Press Enter Key"
                                  // value={template.dockerimage}
                                  value={template.dockertext}
                                  // onChange={(e) =>
                                  //   this._handleOnChange("dockerimage", e.target.value)
                                  // }
                                  onChange={(e) =>
                                    this.setState({
                                      template: {
                                        ...this.state.template,
                                        dockertext: e.target.value,
                                      },
                                    })
                                  }
                                  onKeyPress={(e) =>
                                    e.key === "Enter" &&
                                    e.target.value.trim() !== "" &&
                                    this._handleOnChange("dockerimage", e.target.value)
                                  }
                                >
                                  {" "}
                                </Input>
                                {/* <option>Select</option>
                          {this.state.imageList &&
                            this.state.imageList.map((item) => (
                              <option value={item.id}>{item.name}</option>
                            ))} */}
                                {errors && (
                                  <div className="validation-error">
                                    {errors.dockerimage}
                                  </div>
                                )}
                                {template.dockerimage.map((each) => (
                                  <Badge color="secondary">
                                    {each}
                                    <Button color="link">
                                      <i
                                        className="fa fa-times-circle text-danger"
                                        onClick={() => this._handleOnDockerDelete(each)}
                                      ></i>
                                    </Button>
                                  </Badge>
                                ))}
                              </FormGroup>
                            ) : (
                              <div>
                                <FormGroup>
                                  <Label>
                                    {" "}
                                    VM Images<sup>*</sup>
                                  </Label>
                                  <Input
                                    type="select"
                                    placeholder="VM Images"
                                    value={this.state.template.vmimage}
                                    onChange={(e) =>
                                      this._handleOnChange("vmimage", e.target.value)
                                    }
                                  >
                                    <option>Select</option>
                                    {/* <option>Option 1</option>
                            <option>Option 2</option> */}
                                    {this.state.imageList &&
                                      this.state.imageList.map((item) => (
                                        <option value={item.id}>{item.name}</option>
                                      ))}
                                  </Input>

                                  {errors && (
                                    <div className="validation-error">
                                      {errors.vmimage}
                                    </div>
                                  )}

                                  {preView.map((each) => (
                                    <Badge color="secondary">
                                      {each.name}
                                      <Button color="link">
                                        <i
                                          className="fa fa-times-circle text-danger"
                                          onClick={() => this._handleOnDelete(each.id)}
                                        ></i>
                                      </Button>
                                    </Badge>
                                  ))}
                                </FormGroup>

                                {/* {this.state.template.vmimage &&
                        this.state.template.vmimage.forEach(each=>
                           this.state.imageList.map(item=>
                            item.id==each
                            )
                        )} */}
                                {/* <Badge color="secondary">
                              Image 1
                              <Button color="link">
                                <i
                                  className="fa fa-times-circle text-danger"
                                  // onClick={() => this._handleOnDelete(each.id)}
                                ></i>
                              </Button>
                            </Badge> */}
                              </div>
                            )
                          }
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormGroup>
                            <Label>Default Icon</Label>
                            {/* <Input
                        type="select"
                        placeholder="Name"
                        // value={user.name}
                        onChange={(e) =>
                          this._handleOnChange("defaulticon", e.target.value)
                        }
                      > */}
                            {/* <option>Select</option>
                        <option>Option 1</option>
                        <option>Option 2</option>
                        <option>Option 3</option>
                        <option>Option 4</option> */}
                            {/* {this.state?.iconList.map(item=>(
                          <option>{item.name}</option>
                        ))} */}
                            <Select
                              placeholder="Select Image"
                              multi={true}
                              keepOpen={false}
                              searchable={false}
                              optionRenderer={this._customOptionRenderer}
                              itemRenderer={this._customItemRenderer}
                              onChange={(value) =>
                                this._handleOnChange("pictureId", value)
                              }
                              values={this.state.selectedIcons}
                              // options={data?.iconList}
                              options={this.state?.iconList}
                              labelField={"name"}
                              valueField={"id"}
                              closeOnSelect={true}
                            />
                            {/* </Input> */}
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <FormGroup>
                            <Label>
                              Default{" "}
                              {
                                // eslint-disable-next-line
                                this.state.template.baseBin == "docker"
                                  ? "Docker"
                                  : "VM"
                              }
                              Image
                            </Label>
                            <Input
                              type="select"
                              placeholder="Default Vm Image"
                              // value={user.name}
                              value={this.state.template.defaultvmimage}
                              onChange={(e) =>
                                this._handleOnChange("defaultvmimage", e.target.value)
                              }
                            >
                              <option>Select</option>
                              {preView.map((each) => (
                                <option value={each.id}>{each.name}</option>
                              ))}
                              {template.dockerimage.map((each) => (
                                <option value={each}>{each}</option>
                              ))}
                            </Input>
                          </FormGroup>
                        </Col>
                        <Col md="6">
                          <div
                            className="ml-4"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <FormGroup>
                              <Label
                                check
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                <Tooltip className="float-right" title="Active" arrow>
                                  <Switch
                                    onChange={(e) =>
                                      this._handleOnChange("active", e.target.checked)
                                    }
                                    // defaultChecked
                                    color="warning"
                                  />
                                </Tooltip>
                                Active
                              </Label>
                            </FormGroup>
                            &nbsp; &nbsp;
                            <FormGroup>
                              <Label
                                check
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                <Tooltip
                                  className="float-right"
                                  title="Required Second Disk"
                                  arrow
                                >
                                  <Switch
                                    onChange={(e) =>
                                      this._handleOnChange("active", e.target.checked)
                                    }
                                    color="warning"
                                  />
                                </Tooltip>
                                Required Second Disk
                              </Label>
                            </FormGroup>
                          </div>
                        </Col>
                      </Row>
                      <div className="text-right">
                        {" "}
                        {/* <Button className="addBtn" onClick={() => this._Template()}>
                  Save
                </Button> */}
                      </div>

                      {/* path Emulation profile */}
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <FormGroup>
                    <div className="d-flex justify-content-between">
                      <Label>Fields to Show</Label>
                      <div className="d-flex align-item-center">
                        <Label className="mr-2">Input</Label>
                        {/* <Switch
                          onChange={this.handleChange}
                          checked={this.state.input}
                          uncheckedIcon={""}
                          checkedIcon={""}
                          onColor={"#f18f3c"}
                        /> */}
                        <Tooltip className='float-right' title='View Raw' arrow>
                          <Switch onChange={this.handleChange} checked={this.state.input} defaultChecked color='warning' />
                        </Tooltip>
                        <Label className="ml-2">Raw</Label>
                      </div>
                    </div>
                  </FormGroup>

                  {/* <FormGroup>
                          <Label>Destination</Label>
                          <Input
                            type="textarea"
                            placeholder="Destination"
                            // value={user.name}
                            // onChange={(e) =>
                            //   this._handleOnChange("name", e.target.value)
                            // }
                          />
                        </FormGroup> */}

                  <Card>
                    {!this.state.input ? (
                      VmTemplate.map((item, index) => (
                        <CardBody>
                          {/* <Input
                            type="checkbox"
                            placeholder="Selected"
                            className="checkBox"
                            onClick={(e) =>
                              this._fieldOnChange(
                                "isSelected",
                                e.target.checked,
                                item,
                                index
                              )
                            }
                            checked={item?.isSelected || ""}
                          /> */}

                          <FormGroup>
                            <Label
                              check
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <Tooltip className="float-right" title="Select" arrow>
                                <Switch
                                  onClick={(e) =>
                                    this._fieldOnChange(
                                      "isSelected",
                                      e.target.checked,
                                      item,
                                      index
                                    )
                                  }
                                  checked={item?.isSelected || ""}
                                  // defaultChecked
                                  color="warning"
                                />
                              </Tooltip>
                              Select
                            </Label>
                          </FormGroup>

                          <Row style={{ marginLeft: '0px' }}>
                            <Col md="2">
                              <FormGroup>
                                <Label>Field Name</Label>
                                <Input
                                  type="text"
                                  placeholder="File Name"
                                  value={item.fieldName}
                                  onChange={(e) =>
                                    this._fieldOnChange(
                                      "fieldName",
                                      e.target.value,
                                      item,
                                      index
                                    )
                                  }
                                  readOnly
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup>
                                <Label> Data Type</Label>
                                <Input
                                  type="select"
                                  placeholder="Data Type"
                                  value={item.dataType || ''}
                                  onChange={(e) =>
                                    this._fieldOnChange(
                                      "dataType",
                                      e.target.value,
                                      item,
                                      index
                                    )
                                  }
                                  readOnly
                                >
                                  <option>Select</option>
                                  <option value="Number">Number</option>
                                  <option value="String">String</option>
                                  <option value="Boolean">Boolean</option>
                                  <option value="Array">Array</option>
                                </Input>
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup>
                                <Label> Default Value</Label>
                                {item.dataType !== "Boolean" &&
                                  item.dataType !== "Array" ? (
                                  <>
                                    <Input
                                      type={
                                        // eslint-disable-next-line
                                        item.dataType == "Number"
                                          ? "number"
                                          : "text"
                                      }
                                      placeholder="Default Value"
                                      value={item.defaultValue || ''}
                                      onChange={(e) =>
                                        this._fieldOnChange(
                                          "defaultValue",
                                          e.target.value,
                                          item,
                                          index
                                        )
                                      }
                                    />
                                  </>
                                ) :
                                  // eslint-disable-next-line
                                  item.dataType == "Array" ? (
                                    <>
                                      <Input
                                        type="text"
                                        placeholder="Enter Comma Separated value"
                                        // value={this.state.tempDefaultvalue}
                                        value={item.defaultValue || ''}
                                        onChange={
                                          (e) =>
                                            this._fieldOnChange(
                                              "defaultValue",
                                              e.target.value,
                                              item,
                                              index
                                            )
                                          // console.log(e.target.value.split(','))
                                        }
                                      // onChange={(e) =>
                                      //   this.setState({
                                      //     tempDefaultvalue: e.target.value,
                                      //   })
                                      // }
                                      // onKeyPress={(e) =>
                                      //   e.key === "Enter" &&
                                      //   e.target.value !== "" &&
                                      //   this._fieldOnDefaultChange(
                                      //     "defaultValue",
                                      //     e.target.value,
                                      //     item,
                                      //     index
                                      //   )
                                      // }
                                      />
                                      {item.defaultValue !== undefined &&
                                        this.checkArrayHasDuplicate(
                                          item?.defaultValue.split(",")
                                        ) && (
                                          <div className="validation-error">
                                            Duplicate Value Exits
                                          </div>
                                        )}
                                      {/* {item?.defaultValue?.map((each) => (
                                        <Badge color="secondary">
                                          {each}
                                          <Button color="link">
                                            <i
                                              className="fa fa-times-circle text-danger"
                                              onClick={() =>
                                                this._handleOnDefaultvalueDelete(
                                                  item,
                                                  each
                                                )
                                              }
                                            ></i>
                                          </Button>
                                        </Badge>
                                      ))} */}
                                    </>
                                  ) : (
                                    <div className="d-flex justify-content-center">
                                      <div>
                                        <Label check>
                                          <Input
                                            type="checkbox"
                                            placeholder="defaultValue"
                                            onChange={(e) =>
                                              this._fieldOnChange(
                                                "defaultValue",
                                                e.target.checked,
                                                item,
                                                index
                                              )
                                            }
                                            checked={item?.defaultValue || ""}
                                          />{" "}
                                          {item?.defaultValue
                                            ? "True"
                                            : "false"}
                                        </Label>
                                      </div>
                                      <div className="ml-4">
                                        <Label check>
                                          <Input
                                            type="checkbox"
                                            placeholder="default value"
                                            onClick={(e) =>
                                              this._fieldOnChange(
                                                "defaultValue",
                                                false,
                                                item,
                                                index
                                              )
                                            }
                                            checked={item?.defaultValue}
                                          />{" "}
                                          False
                                        </Label>
                                      </div>
                                    </div>
                                  )}
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <FormGroup>
                                <Label> Label</Label>
                                <Input
                                  type="text"
                                  placeholder="Label"
                                  // value={item.label}
                                  value={item.label || ''}
                                  onChange={(e) =>
                                    this._fieldOnChange(
                                      "label",
                                      e.target.value,
                                      item,
                                      index
                                    )
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col md="2">
                              <div className="mt-4 ml-4">
                                {" "}
                                {/* <FormGroup>
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      placeholder="Mandatory"
                                      onChange={(e) =>
                                        this._fieldOnChange(
                                          "isMandatory",
                                          e.target.checked,
                                          item,
                                          index
                                        )
                                      }
                                      checked={item?.isMandatory || ""}
                                    />{" "}
                                    Mandatory
                                  </Label>
                                </FormGroup> */}

                                <FormGroup>
                                  <Label
                                    check
                                    style={{ display: "flex", alignItems: "center" }}
                                  >
                                    <Tooltip className="float-right" title="Mandatory" arrow>
                                      <Switch
                                        onChange={(e) =>
                                          this._fieldOnChange(
                                            "isMandatory",
                                            e.target.checked,
                                            item,
                                            index
                                          )
                                        }
                                        checked={item?.isMandatory || ""}
                                        // defaultChecked
                                        color="warning"
                                      />
                                    </Tooltip>
                                    Mandatory
                                  </Label>
                                </FormGroup>

                              </div>
                            </Col>
                            <Col md="2">
                              <div className="mt-4 ml-4">
                                <FormGroup>
                                  <Label
                                    check
                                    style={{ display: "flex", alignItems: "center" }}
                                  >
                                    <Tooltip className="float-right" title="Editable" arrow>
                                      <Switch
                                        onChange={(e) =>
                                          this._fieldOnChange(
                                            "isEditable",
                                            e.target.checked,
                                            item,
                                            index
                                          )
                                        }
                                        checked={item?.isEditable || ""}
                                        // defaultChecked
                                        color="warning"
                                      />
                                    </Tooltip>
                                    Editable
                                  </Label>
                                </FormGroup>
                              </div>
                            </Col>

                            <hr style={{ width: "100%", height: '0.5px', backgroundColor: "gray" }} />
                          </Row>
                          <Row style={{ marginLeft: '0px' }}>
                            {/* <Col md="4">
                              <FormGroup>
                                <Label> Label</Label>
                                <Input
                                  type="text"
                                  placeholder="Label"
                                  // value={item.label}
                                  value={item.label || ''}
                                  onChange={(e) =>
                                    this._fieldOnChange(
                                      "label",
                                      e.target.value,
                                      item,
                                      index
                                    )
                                  }
                                />
                              </FormGroup>
                            </Col> */}
                            {/* <Col md="4">
                              <div className="mt-4 ml-4">
                                {" "}
                                <FormGroup>
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      placeholder="Mandatory"
                                      onChange={(e) =>
                                        this._fieldOnChange(
                                          "isMandatory",
                                          e.target.checked,
                                          item,
                                          index
                                        )
                                      }
                                      checked={item?.isMandatory || ""}
                                    />{" "}
                                    Mandatory
                                  </Label>
                                </FormGroup>
                              </div>
                            </Col> */}
                            {/* <Col md="4">
                              <div className="mt-4 ml-4">
                                {" "}
                                <FormGroup>
                                  <Label check>
                                    <Input
                                      type="checkbox"
                                      placeholder="Editable"
                                      onChange={(e) =>
                                        this._fieldOnChange(
                                          "isEditable",
                                          e.target.checked,
                                          item,
                                          index
                                        )
                                      }
                                      checked={item?.isEditable || ""}
                                    />{" "}
                                    Editable
                                  </Label>
                                </FormGroup>
                              </div>
                            </Col> */}
                          </Row>
                        </CardBody>
                      ))
                    ) : (
                      <FormGroup>
                        <Input
                          type="textarea"
                          placeholder="Enter Valid JSON"
                          name="textArea"
                          // value={JSON.stringify(this.state.fieldsToShow)}
                          value={this.state.template.textArea}
                          onChange={(e) =>
                            this._handleOnChange("textArea", e.target.value)
                          }
                          // onBlur={(e) => this._validJson(e.target.value)}
                          onBlur={(e) =>
                            this.markDirty(e.target.name, e.target.value)
                          }
                          style={{ height: "200px", maxHeight: "200px" }}
                        />
                        {errors && (
                          <div className="validation-error">
                            {errors.textArea}
                          </div>
                        )}
                      </FormGroup>
                    )}
                    {/* {!this.state.input ? (
                            <div className="d-flex justify-content-center">
                              {" "}
                              <Button
                                className="addBtn"
                                //   onClick={() => this._onToggleAddTeamModal()}
                              >
                                <i className="fa fa-plus mr-1"></i> Add
                              </Button>{" "}
                            </div>
                          ) : null} */}
                  </Card>
                </Col>
              </Row>

              <div className="text-right">
                {" "}
                <Button className="addBtn" onClick={() => this._Template()}>
                  Save
                </Button>
              </div>

              {/* path Emulation profile */}
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loaderData: state.loaderData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    showLoader: (loaderData) => dispatch(showLoader(loaderData)),
    hideLoader: (loaderData) => dispatch(hideLoader(loaderData)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateCreation);
